import { render, staticRenderFns } from "./CustomerOrthoIprs.vue?vue&type=template&id=7546b116"
import script from "./CustomerOrthoIprs.vue?vue&type=script&lang=js"
export * from "./CustomerOrthoIprs.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrthoIprs.vue?vue&type=style&index=0&id=7546b116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports